import React, { Component } from 'react';
import "./upgradeItempopup.scss";
import Veg from '../../../src/View/svg/items/veg';
import NonVeg from '../../../src/View/svg/items/nonveg';
import Egg from '../../../src/View/svg/items/egg';

class UpgradeItemPopup extends Component {
  constructor(props) {
    super(props);
    
    this.state = {
      quantity: 1
    };

    this.defaultItemData = {
      name: "White Velvet - Absolut Vodka",
      price: 800,
      description: "Absolute Vodka|White Chocolate|Crea...more",
      image: null
    };

    this.handleIncrement = this.handleIncrement.bind(this);
    this.handleDecrement = this.handleDecrement.bind(this);
    this.handleQuantityChange = this.handleQuantityChange.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.handleUpgrade = this.handleUpgrade.bind(this);
    this.handleKeepSame = this.handleKeepSame.bind(this);
    this.handleOverlayClick = this.handleOverlayClick.bind(this);
  }

  // ✅ When popup opens/closes — check cart and set quantity
  componentDidUpdate(prevProps) {
    const { itemData } = this.props;
    const isCustomisable = itemData?.modifierGroupIds?.length > 0;

    // Reset quantity when popup closes
    if (prevProps.isOpen !== this.props.isOpen && !this.props.isOpen) {
      this.setState({ quantity: 1 });
    }

    // When popup opens, check cart
    if (!prevProps.isOpen && this.props.isOpen && itemData) {
      try {
        const storedCart = sessionStorage.getItem("cartList");
        if (!storedCart) return;

        const cartList = JSON.parse(storedCart);
        if (!cartList?.itemList?.length) return;

        // Find item by itemId
        const existingItem = cartList.itemList.find(
          (itm) => itm.itemId === itemData.itemId
        );

        if (isCustomisable) {
          // Always set quantity to 1 for customisable items
          this.setState({ quantity: 1 });
        } else {
          // Set quantity from cart if exists
          this.setState({ quantity: existingItem ? existingItem.qty : 1 });
        }
      } catch (e) {
        console.error("Invalid cartList in sessionStorage:", e);
      }
    }
  };


  handleIncrement() {
    this.setState(prevState => ({
      quantity: prevState.quantity + 1
    }));
  }

  handleDecrement() {
    this.setState(prevState => ({
      quantity: prevState.quantity > 1 ? prevState.quantity - 1 : 1
    }));
  }

  handleQuantityChange(e) {
    const value = parseInt(e.target.value) || 1;
    if (value >= 1) {
      this.setState({ quantity: value });
    }
  }

  handleClose() {
    this.setState({ quantity: 1 });
    if (this.props.onClose) {
      this.props.onClose();
    }
  }

  handleUpgrade() {
    const { itemData = this.defaultItemData, onUpgrade } = this.props;
    const { quantity } = this.state;

    if (onUpgrade) {
      onUpgrade({
        ...itemData,
        quantity: quantity,
        totalPrice: itemData.rate * quantity
      });
    }

    this.handleClose();
  }

  handleKeepSame() {
    const { itemData = this.defaultItemData, onKeepSame } = this.props;
    const { quantity } = this.state;

    if (onKeepSame) {
      onKeepSame({
        ...itemData,
        quantity: quantity
      });
    }

    this.handleClose();
  }

  handleOverlayClick(e) {
    if (e.target === e.currentTarget) {
      this.handleClose();
    }
  }

  render() {
    const { isOpen = false, itemData = this.defaultItemData } = this.props;
    const { quantity } = this.state;

    if (!isOpen) return null;

    // ✅ Declare this BEFORE return
    const isCustomisable = itemData.modifierGroupIds && itemData.modifierGroupIds.length > 0;

    return (
      <div className="upgrade-popup-overlay" onClick={this.handleOverlayClick}>
        <div className="upgrade-popup-container">
          {/* Header */}
          <div className="upgrade-popup-header">
            <h3 className="upgrade-popup-title">Upgrade Your Item?</h3>
            <button 
              className="upgrade-popup-close" 
              onClick={this.handleClose}
              aria-label="Close popup"
            >
              ✕
            </button>
          </div>

          {/* Subtitle */}
          <p className="upgrade-popup-subtitle">
            Enhances your experience with a premium option
          </p>
          <hr className="upgrade-popup-divider" />

          {/* Item Details */}
          <div className="upgrade-item-card">
            <div className="upgrade-item-checkbox">
              {itemData.foodType === 1 && <Veg />}
              {itemData.foodType === 2 && <NonVeg />}
              {itemData.foodType === 3 && <Egg />}
            </div>
            
            <div className="upgrade-item-details">
              <h4 className="upgrade-item-name">{itemData.itemName}</h4>
              <p className="upgrade-item-price">₹{itemData.rate}</p>
              <p className="upgrade-item-description">
                {itemData.description.length > 25 
                  ? `${itemData.description.slice(0, 25)}...more` 
                  : itemData.description
                }
              </p>
            </div>

            {/* Quantity Controls */}
            <div>
              <div className="upgrade-quantity-controls">
                <button 
                  className="quantity-btn quantity-btn-minus"
                  onClick={this.handleDecrement}
                  disabled={quantity <= 1}
                  aria-label="Decrease quantity"
                >
                  −
                </button>
                <input 
                  type="number" 
                  className="quantity-input"
                  value={quantity} // ✅ always show 1 if customisable
                  onChange={this.handleQuantityChange}
                  min="1"
                  aria-label="Quantity"
                />
                <button 
                  className="quantity-btn quantity-btn-plus"
                  onClick={this.handleIncrement}
                  aria-label="Increase quantity"
                >
                  +
                </button>
              </div>

              {/* Customisable Indicator */}
              {itemData.modifierGroupIds && itemData.modifierGroupIds.length > 0 && (
                <div className="upgrade-customisable" style={{ textAlign: "center"}}>
                  <span 
                    className="modifier-notify dm-customize-fnt-clr"
                    style={{ cursor: "pointer", fontSize: "13px", fontWeight: "500", color:"rgb(126, 128, 140)" }}
                  >
                    Customisable
                  </span>
                </div>
              )}
            </div>
          </div>

          {/* Action Buttons */}
          <div className="upgrade-popup-actions">
            <button 
              className="upgrade-btn-keep-same"
              onClick={this.handleKeepSame}
            >
              Keep It Same
            </button>
            <button 
              className="upgrade-btn-upgrade"
              onClick={this.handleUpgrade}
            >
              Upgrade
            </button>
          </div>
        </div>
      </div>
    );
  }
}

export default UpgradeItemPopup;
